<template>
<div>
    <el-alert class="mb-3" v-if="alert.message" effect="dark" :type="alert.type" :description="alert.message" show-icon :closable="false"></el-alert>
    <v-content-layout>
        <template #header>
            <FilterOption />
            <div>
                <el-input class="ml-2" prefix-icon="el-icon-search" placeholder="Search" v-model="search" clearable></el-input>
            </div>
            <v-spacer></v-spacer>
            <el-button icon="mdi mdi-upload" type="primary" @click="viewImportForm"> Import</el-button>
            <v-export-table class="ml-2" text="Export" :tableColumns="exportTableColumns" :tableData="items" :filename="`QB_USER_LOGS-${Date.now()}`" :filesheet="`qb-user-logs`" />
            <el-button class="ml-2" icon="mdi mdi-sync" type="success" @click="loadQBLogs({})"> Refresh</el-button>
        </template>
        <template #body>
            <e-table :data="items" :total="items.length" :headers="headers" :search="search" :height="window.height - 170" :loading="loading">
                <template #actions="{scope}">
                    <span v-if="scope.row.status === 1">-</span>
                    <el-dropdown size="mini" v-if="scope.row.status === 2" trigger="click" split-button type="primary" @click="viewBills(scope.row)">
                        View Bills
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item icon="el-icon-download" @click.native="$downloadFile(`Quickbook_${scope.row.batchId}.xlsx`, scope.row.fileLink)">Download Template</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </template>

                <template #footer>
                    <el-button type="danger" @click="disconnect" :disabled="loading">Disconnect</el-button>
                    <span id="qbStatus" class="ml-2" style="font-size:13px;color:white">Status: <strong style="color:#34e062;">Connected</strong></span>
                </template>
            </e-table>
        </template>
    </v-content-layout>
    <BillsList ref="billsList" />
    <ImportForm ref="importForm" @onSuccess="onImportSuccess" @onError="onImportError" />
</div>
</template>

<script>
import {
    mapGetters,
    mapActions
} from 'vuex';
import * as type from '../../store/types';
import FilterOption from './components/FilterOption';
import BillsList from './components/BillsList';
import ImportForm from './components/ImportForm';

export default {
    components: {
        FilterOption,
        BillsList,
        ImportForm
    },
    props: {
        handleDisconnect: Function
    },
    data: () => ({
        search: '',
        timer: '',
        alert: {
            type: "error",
            message: ""
        }
    }),
    computed: {
        ...mapGetters({
            headers: `quickbooklogs/headers`,
            items: `quickbooklogs/items`,
            loading: 'quickbooklogs/loading',
        }),
        exportTableColumns() {
            return this.headers.map(e => {
                return {
                    label: e.text,
                    field: e.value
                }
            })
        },
    },
    mounted() {
        this.loadQBLogs({});
        this.timer = setInterval(() => {
            this.loadQBLogs({})
        }, 60000);
    },
    methods: {
        ...mapActions({
            loadQBLogs: `quickbooklogs/${type.QB_GET_LOGS}`,
            disconnect: `quickbooks/${type.QB_DISCONNECT}`
        }),
        viewBills(items) {
            this.$refs['billsList'].viewBillsList(items.batchId);
        },
        viewImportForm() {
            this.$refs['importForm'].viewImportForm();
        },
        onImportSuccess(success) {
            this.alert = success
            this.loadQBLogs({})
        },
        onImportError(error) {
            this.alert = error
            this.loadQBLogs({})
        }
    }
}
</script>
